module.exports = __webpack_public_path__ + "img/Big-Apartment.9b84ccfd.png";